module.exports = __webpack_public_path__ + "media/images/sports_coaching/main_image1@2x-b89b56bd4da64920c7a9330200981346.jpg";